import { NotFoundPage } from '~/components';
import {
  DashboardAdmin,
  ActivityReportAdmin,
  StaffSaleReportAdmin,
  LeadReportAdmin,
  SaleReportAdmin,
  FranchiseMKTReportAdmin,
  ProjectReportAdmin,
  SourceReferralReportAdmin,
  ClosingRateReportAdmin,
  LoginAdmin,
  SignUpAdmin,
  HomeUser,
  ScheduleAdmin,
  JobAdmin,
  JobDetailAdmin,
  AccountAdmin,
  ContactAdmin,
  CRMAdmin,
  TimeClockAdmin,
  InvoiceAdmin,
  EstimateAdmin,
  ReportAdmin,
  ProfileAdmin,
  AccountSettingAdmin,
  Component,
  Message,
  Franchise,
  Quickbook,
  QuickbookAuthCallback,
  ForgotPasswordAdmin,
  ResetPasswordAdmin,
  PriceComponentAdmin,
  PriceAdmin,
  PriceItemAdmin,
  CustomerAdmin,
  CustomerDetailAdmin,
  ContactDetailAdmin,
  TemplateEmailAdmin,
  TemplateEstimateAdmin,
  TemplateTermConditionAdmin,
  TemplateOpenningStatement,
  CallAdmin,
  MessageAdmin,
  SelectFranchiseAdmin,
  RingCentral,
  Location,
  CompanyRole,
  AreaScopeDetail,
  EquipmentAdmin,
  Campaign,
  FranchiseTaskAdmin,
  JobStatusAdmin,
  CRMStatusAdmin,
  RingCentralMobile,
  DeleteAccount,
  EsignCompleted,
  FilePreview,
  JobTypeAdmin,
  TimeClockReport,
} from '~/pages';
import AreaPsychorometricReadings from '~/pages/admin/jobs/job-detail/components/areaScope/AreaPsychrometricReadings';
import AreaScopeMoisturePoints from '~/pages/admin/jobs/job-detail/components/areaScope/AreaScopeMoisturePoints';
import AreaScopeMoisturePointList from '~/pages/admin/jobs/job-detail/components/areaScope/AreaScopeListMoisturePoints';

import { IRouteModel } from '../interface/common';

// Router && Path
export const adminRoute = {
  base: '/admin',
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  selectFranchise: '/select-franchise',
  dashboard: '/dashboard',
  franchise: '/franchise',
  schedule: '/schedule',
  jobs: '/jobs',
  jobDetail: '/jobs/detail/:id',
  areaScopeDetail: '/jobs/detail/:id/area-scope/:areaId',
  areaScopeMoistualScopeDetail: '/jobs/detail/:id/moistual-scopes/:index',
  areaScopeMoistualScopeList: '/jobs/detail/:id/moistual-scopes/list/:index',
  areaScopePsychrometricReadings: '/jobs/detail/:id/psychrometic-readings',
  users: '/users',
  contacts: '/contacts',
  cRM: '/crm',
  call: '/call',
  timeClocks: '/time-clocks',
  invoices: '/invoices',
  estimates: '/estimates',
  priceComponents: '/price-components',
  prices: '/prices',
  priceItems: '/price-items',
  reports: '/reports',
  profile: '/profile',
  accountSetting: '/account-setting',
  components: '/components',
  message: '/message',
  quickbooks: '/quickbooks',
  quickbookAuthCallback: '/quickbooks/auth/callback',
  ringCentral: '/ring-central',
  customers: '/customers',
  customerDetail: '/customers/detail/:id',
  contactDetail: '/contacts/detail/:id',
  templateEmail: '/templates/email',
  templateEstimate: '/templates/estimate',
  templateTermCondition: '/templates/terms-conditions',
  templateOpenningStatement: '/templates/opening-statements',
  location: '/location',
  companyRoles: '/company-roles',
  equipments: '/equipments',
  campaigns: '/campaigns',
  tasks: '/tasks',
  jobStatuses: '/job-statuses',
  crmStatuses: '/crm-statuses',
  jobTypes: '/job-types',
  activityReport: '/reports/activities',
  leadReport: '/reports/leads',
  saleReport: '/reports/sale',
  franchiseMKTReport: '/reports/franchise-marketing',
  staffSaleReport: '/reports/staff-sale',
  closingRateReport: '/reports/closing-rate',
  projectReport: '/reports/projects',
  sourceReferral: '/reports/source-referrals',
  timeClockReport: '/reports/time-clock',
  ringCentralMobile: '/ring-central-mobile',
  deleteAccount: '/delete-account',
  esignCompleted: '/esigns/completed',
  filePreview: '/files/preview/:id',
};

export const userRoute = {
  base: '/',
  home: '/home',
  component: '/component',
};

export const contactusRoute = {
  base: '/contact-us',
};
export const policyRoute = {
  base: '/policy',
};

export const licenseAgreementRoute = {
  base: '/license-agreement',
};

//#region Admin Routes
export const publicAdminRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.login}`,
    component: LoginAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.signUp}`,
    component: SignUpAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.forgotPassword}`,
    component: ForgotPasswordAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.resetPassword}`,
    component: ResetPasswordAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.selectFranchise}`,
    component: SelectFranchiseAdmin,
  },
  {
    path: `${adminRoute.base}${adminRoute.ringCentralMobile}`,
    component: RingCentralMobile,
  },
  {
    path: `${adminRoute.base}${adminRoute.deleteAccount}`,
    component: DeleteAccount,
  },
  {
    path: `${adminRoute.base}${adminRoute.esignCompleted}`,
    component: EsignCompleted,
  },
  {
    path: `${adminRoute.base}${adminRoute.filePreview}`,
    component: FilePreview,
  },
];

export const privateAdminRoutes: IRouteModel[] = [
  {
    path: `${adminRoute.base}${adminRoute.dashboard}`,
    component: DashboardAdmin,
    name: 'Dashboard',
  },
  {
    path: `${adminRoute.base}${adminRoute.activityReport}`,
    component: ActivityReportAdmin,
    name: 'ActivityReport',
  },
  {
    path: `${adminRoute.base}${adminRoute.leadReport}`,
    component: LeadReportAdmin,
    name: 'LeadReport',
  },

  {
    path: `${adminRoute.base}${adminRoute.saleReport}`,
    component: SaleReportAdmin,
    name: 'SaleReport',
  },

  {
    path: `${adminRoute.base}${adminRoute.franchiseMKTReport}`,
    component: FranchiseMKTReportAdmin,
    name: 'FranchiseMKTReport',
  },

  {
    path: `${adminRoute.base}${adminRoute.staffSaleReport}`,
    component: StaffSaleReportAdmin,
    name: 'StaffSaleReport',
  },

  {
    path: `${adminRoute.base}${adminRoute.closingRateReport}`,
    component: ClosingRateReportAdmin,
    name: 'ClosingRateReport',
  },

  {
    path: `${adminRoute.base}${adminRoute.projectReport}`,
    component: ProjectReportAdmin,
    name: 'ProjectReport',
  },
  {
    path: `${adminRoute.base}${adminRoute.sourceReferral}`,
    component: SourceReferralReportAdmin,
    name: 'SourceReferralReport',
  },
  {
    path: `${adminRoute.base}${adminRoute.timeClockReport}`,
    component: TimeClockReport,
    name: 'TimeClockReport',
  },
  {
    path: `${adminRoute.base}${adminRoute.franchise}`,
    component: Franchise,
    name: 'Franchise',
  },
  {
    path: `${adminRoute.base}${adminRoute.schedule}`,
    component: ScheduleAdmin,
    name: 'Schedule',
  },
  {
    path: `${adminRoute.base}${adminRoute.jobs}`,
    component: JobAdmin,
    name: 'Job',
  },
  {
    path: `${adminRoute.base}${adminRoute.jobDetail}`,
    component: JobDetailAdmin,
    name: 'JobDetail',
  },

  {
    path: `${adminRoute.base}${adminRoute.areaScopeDetail}`,
    component: AreaScopeDetail,
    name: 'AreaScopeDetail',
  },
  {
    path: `${adminRoute.base}${adminRoute.areaScopeMoistualScopeDetail}`,
    component: AreaScopeMoisturePoints,
    name: 'AreaScopeMoisturePoints',
  },
  {
    path: `${adminRoute.base}${adminRoute.areaScopeMoistualScopeList}`,
    component: AreaScopeMoisturePointList,
    name: 'AreaScopeMoisturePointList',
  },
  {
    path: `${adminRoute.base}${adminRoute.areaScopePsychrometricReadings}`,
    component: AreaPsychorometricReadings,
    name: 'AreaScopePsychorometricReadings',
  },
  {
    path: `${adminRoute.base}${adminRoute.message}`,
    component: Message,
    name: 'Message',
  },
  {
    path: `${adminRoute.base}${adminRoute.users}`,
    component: AccountAdmin,
    name: 'User',
  },
  {
    path: `${adminRoute.base}${adminRoute.contacts}`,
    component: ContactAdmin,
    name: 'Contact',
  },
  {
    path: `${adminRoute.base}${adminRoute.cRM}`,
    component: CRMAdmin,
    name: 'CRM',
  },
  {
    path: `${adminRoute.base}${adminRoute.call}`,
    component: CallAdmin,
    name: 'Call',
  },
  {
    path: `${adminRoute.base}${adminRoute.message}`,
    component: MessageAdmin,
    name: 'Message',
  },

  {
    path: `${adminRoute.base}${adminRoute.timeClocks}`,
    component: TimeClockAdmin,
    name: 'TimeClock',
  },
  {
    path: `${adminRoute.base}${adminRoute.invoices}`,
    component: InvoiceAdmin,
    name: 'Invoice',
  },
  {
    path: `${adminRoute.base}${adminRoute.estimates}`,
    component: EstimateAdmin,
    name: 'Estimate',
  },
  {
    path: `${adminRoute.base}${adminRoute.priceComponents}`,
    component: PriceComponentAdmin,
    name: 'PriceComponent',
  },
  {
    path: `${adminRoute.base}${adminRoute.prices}`,
    component: PriceAdmin,
    name: 'Price',
  },
  {
    path: `${adminRoute.base}${adminRoute.priceItems}`,
    component: PriceItemAdmin,
    name: 'PriceItem',
  },
  {
    path: `${adminRoute.base}${adminRoute.equipments}`,
    component: EquipmentAdmin,
    name: 'Equipment',
  },
  {
    path: `${adminRoute.base}${adminRoute.jobStatuses}`,
    component: JobStatusAdmin,
    name: 'JobStatus',
  },
  {
    path: `${adminRoute.base}${adminRoute.jobTypes}`,
    component: JobTypeAdmin,
    name: 'JobType',
  },
  {
    path: `${adminRoute.base}${adminRoute.crmStatuses}`,
    component: CRMStatusAdmin,
    name: 'CRMStatus',
  },
  {
    path: `${adminRoute.base}${adminRoute.tasks}`,
    component: FranchiseTaskAdmin,
    name: 'FranchiseTask',
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}`,
    component: ReportAdmin,
    name: 'Report',
  },
  {
    path: `${adminRoute.base}${adminRoute.profile}`,
    component: ProfileAdmin,
    name: 'Profile',
  },
  {
    path: `${adminRoute.base}${adminRoute.accountSetting}`,
    component: AccountSettingAdmin,
    name: 'AccountSetting',
  },
  {
    path: `${adminRoute.base}${adminRoute.components}`,
    component: Component,
    name: 'Components',
  },
  {
    path: `${adminRoute.base}${adminRoute.quickbooks}`,
    component: Quickbook,
    name: 'Quickbooks',
  },
  {
    path: `${adminRoute.base}${adminRoute.quickbookAuthCallback}`,
    component: QuickbookAuthCallback,
    name: 'QuickbookAuthCallback',
  },
  {
    path: `${adminRoute.base}${adminRoute.ringCentral}`,
    component: RingCentral,
    name: 'RingCentral',
  },
  {
    path: `${adminRoute.base}${adminRoute.customers}`,
    component: CustomerAdmin,
    name: 'Customer',
  },
  {
    path: `${adminRoute.base}${adminRoute.customerDetail}`,
    component: CustomerDetailAdmin,
    name: 'CustomerDetail',
  },
  {
    path: `${adminRoute.base}${adminRoute.contactDetail}`,
    component: ContactDetailAdmin,
    name: 'ContactDetailAdmin',
  },
  {
    path: `${adminRoute.base}${adminRoute.templateEmail}`,
    component: TemplateEmailAdmin,
    name: 'TemplateEmail',
  },
  {
    path: `${adminRoute.base}${adminRoute.templateEstimate}`,
    component: TemplateEstimateAdmin,
    name: 'TemplateEstimate',
  },
  {
    path: `${adminRoute.base}${adminRoute.templateTermCondition}`,
    component: TemplateTermConditionAdmin,
    name: 'TemplateTermCondition',
  },
  {
    path: `${adminRoute.base}${adminRoute.templateOpenningStatement}`,
    component: TemplateOpenningStatement,
    name: 'TemplateOpeningStatement',
  },
  {
    path: `${adminRoute.base}${adminRoute.location}`,
    component: Location,
    name: 'Location',
  },
  {
    path: `${adminRoute.base}${adminRoute.companyRoles}`,
    component: CompanyRole,
    name: 'CompanyRole',
  },
  {
    path: `${adminRoute.base}${adminRoute.campaigns}`,
    component: Campaign,
    name: 'Campaign',
  },
];
//#endregion Admin Routes

//#region Patient Routes
export const publicUserRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
];

export const privateUserRoutes: IRouteModel[] = [
  {
    path: userRoute.home,
    component: HomeUser,
  },
];
//#endregion Patient Routes

export const publicRoutes = [...publicAdminRoutes, ...publicUserRoutes];

export const privateRoutes = [];

export const adminRouteAbsolute = {
  jobs: `${adminRoute.base}${adminRoute.jobs}`,
  jobDetail: `${adminRoute.base}${adminRoute.jobDetail}`,
  schedule: `${adminRoute.base}${adminRoute.schedule}`,
  dashboard: `${adminRoute.base}${adminRoute.dashboard}`,
  login: `${adminRoute.base}${adminRoute.login}`,
  forgotPassword: `${adminRoute.base}${adminRoute.forgotPassword}`,
  resetPassword: `${adminRoute.base}${adminRoute.resetPassword}`,
  signUp: `${adminRoute.base}${adminRoute.signUp}`,
  profile: `${adminRoute.base}${adminRoute.profile}`,
  accountSetting: `${adminRoute.base}${adminRoute.accountSetting}`,
  message: `${adminRoute.base}${adminRoute.message}`,
  quickbooks: `${adminRoute.base}${adminRoute.quickbooks}`,
  quickbookAuthCallback: `${adminRoute.base}${adminRoute.quickbookAuthCallback}`,
  ringCentral: `${adminRoute.base}${adminRoute.ringCentral}`,
  customerDetail: `${adminRoute.base}${adminRoute.customerDetail}`,
  contactDetail: `${adminRoute.base}${adminRoute.contactDetail}`,
  selectFranchise: `${adminRoute.base}${adminRoute.selectFranchise}`,
  invoices: `${adminRoute.base}${adminRoute.invoices}`,
  areaScopeDetail: `${adminRoute.base}${adminRoute.areaScopeDetail}`,
  areaScopeMoistualPointsDetail: `${adminRoute.base}${adminRoute.areaScopeMoistualScopeDetail}`,
  areaScopeMoistualPointsList: `${adminRoute.base}${adminRoute.areaScopeMoistualScopeList}`,
  areaPsychrometricReadings: `${adminRoute.base}${adminRoute.areaScopePsychrometricReadings}`,
  ringCentralMobile: `${adminRoute.base}${adminRoute.ringCentralMobile}`,
  deleteAccount: `${adminRoute.base}${adminRoute.deleteAccount}`,
  projectReport: `${adminRoute.base}${adminRoute.projectReport}`,
  staffSaleReport: `${adminRoute.base}${adminRoute.staffSaleReport}`,
  saleReport: `${adminRoute.base}${adminRoute.saleReport}`,
  activityReport: `${adminRoute.base}${adminRoute.activityReport}`,
  timeClockReport: `${adminRoute.base}${adminRoute.timeClockReport}`,
};
